import {json} from '../core/data-source/json.mapper';

export enum PrintTemplateType {
    POD = 'POD',
    MANIFEST = 'MANIFEST'
}

export class PrintTemplateRecord {
    @json()
    accountId: string;

    @json()
    id: number;

    @json()
    name: string;

    @json()
    template: string;

    @json()
    options: any;

    @json()
    type: string;

    @json()
    used: boolean;

    @json()
    default?: boolean;
}
